import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fea81d18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "details-content" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "content" }

import SettingsDetails from "@/components/settings/SettingsDetails/SettingsDetails.vue";
import Form from "@/components/layouts/Form.vue";
import GenericButton from "@/components/buttons/GenericButton.vue";
import { useComputedValue } from "@/composables";
import { ActionTypes, GetterTypes } from "@/store";
import { Profile } from "@/store/auth/state";
import { GenericButtonVariantEnum } from "@/types/button";
import { FormFieldNameEnum } from "@/types/form";
import { ref, watch } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import Input from "../forms/Input.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsPersonalDetails',
  setup(__props) {

const name = ref("");
const router = useRouter();
const { dispatch } = useStore();

const profile = useComputedValue<Profile>(GetterTypes.GET_AUTH_PROFILE);

watch(profile, () => {
  hydrateData();
});

const handleSubmit = async () => {
  await dispatch(ActionTypes.UPDATE_USER, {
    name: name.value,
    photo: profile.value.picture,
  });

  router.push("/settings");
};
const hydrateData = () => {
  name.value = profile.value.name;
};

hydrateData();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SettingsDetails, {
    title: _ctx.$t('settings.personalDetails')
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(Form, { onSubmitForm: handleSubmit }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(Input, {
                  modelValue: name.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
                  name: _unref(FormFieldNameEnum).Name,
                  label: "settings.personalDetailsContent.fullName",
                  required: ""
                }, null, 8, ["modelValue", "name"])
              ]),
              _createVNode(GenericButton, {
                variant: _unref(GenericButtonVariantEnum).Primary,
                text: "settings.personalDetailsContent.saveDetails"
              }, null, 8, ["variant"])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})